export default __webpack_public_path__ + "static/media/ECB_BIRD_2023.d982df10.mp4";